import 'core-js/fn/array/find';
//  ADDED LINES 10-12 for IE 11 Support
//  import polyfills from core-js to fix:
//
//  'Object doesn't support property or method....' startsWith
//  'possible unhandled promise' online/offline polling bug
//  'object doesn't support property 'find' from xxxx.worker.js
//  array find reference 
//  https://stackoverflow.com/questions/56269966/object-doesnt-support-property-or-method-find-in-ie-11
import 'core-js/fn/promise';
import 'core-js/fn/string/starts-with';
//import 'core-js/modules/es6.array.find'; //redundant imported by line 1 above

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';

import 'index.css';
import registerServiceWorker from 'lib/registerServiceWorker';
import E2Book from 'app/E2Book';
import Loading from 'app/components/Loading';
import {fetchFromStorage} from 'app/state/AppState';

(async ()=>{
  ReactDOM.render(
    <Loading />,
    document.getElementById('root')
  );
  const AppState = await fetchFromStorage();
  ReactDOM.render(
    <Provider AppState={AppState}>
      <E2Book />
    </Provider>,
    document.getElementById('root')
  );
  
})();
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js